import { lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import CarHireSearchPage from '@components/pages/car-hire-results';
// import MotorHomeSearchPage from '@components/pages/motorhome-search-results';
// import HotelSearchPage from '@components/pages/hotel-search-results';
// import HolidaySearchPage from '@components/pages/holiday-search-results';
// import FlightSearchPage from '@components/pages/flight-search-results';
// import FindMyHolidayPage from '@components/pages/find-my-holiday-search-results';
// import MarketingMaterialSearch from '@components/pages/marketing-material-search-results';
// import FlightSpecialOfferSearch from '@components/pages/flight-special-offer-search-results';

// // components
// import SiteSearchWidget from '@components/templates/site-search-widget'
// import HeaderSearchWidget from '@components/templates/header-search-widget'
// import HomeSearchWidget from '@components/templates/home-search-widget'
// import HotelsBookingWidget from '@components/templates/hotels-booking-widget'
// import MotorHomeBookingWidget from '@components/templates/motorhome-booking-widget'
// import ItineraryBookingWidget from '@components/templates/itinerary-booking-widget'
// import AuthHeader from '@/components/mycaf/organisms/auth-header';

const HeaderSearchWidget = lazy(() => import('@components/templates/header-search-widget'));
const AuthHeader = lazy(() => import('@/components/mycaf/organisms/auth-header'));
const HomeSearchWidget = lazy(() => import('@components/templates/home-search-widget'));
const SiteSearchWidget = lazy(() => import('@components/templates/site-search-widget'));
const MotorHomeBookingWidget = lazy(() => import('@components/templates/motorhome-booking-widget'));
const ItineraryBookingWidget = lazy(() => import('@components/templates/itinerary-booking-widget'));
const HotelsBookingWidget = lazy(() => import('@components/templates/hotels-booking-widget'));

const CarHireSearchPage = lazy(() => import('@components/pages/car-hire-results'));
const MotorHomeSearchPage = lazy(() => import('@components/pages/motorhome-search-results'));
const HotelSearchPage = lazy(() => import('@components/pages/hotel-search-results'));
const HolidaySearchPage = lazy(() => import('@components/pages/holiday-search-results'));
const FindMyHolidayPage = lazy(() => import('@components/pages/find-my-holiday-search-results'));
const MarketingMaterialSearch = lazy(() => import('@components/pages/marketing-material-search-results'));
const FlightSpecialOfferSearch = lazy(() => import('@components/pages/flight-special-offer-search-results'));
const FlightSearchPage = lazy(() => import('@components/pages/flight-search-results'));

// import { AuthHeader } from '@/components/mycaf';

// import Login from '@/pages/Login';
// import Login2 from '@/pages/Login2';

function AppRouter() {
	return (
		<Router>
			<>
				<HomeSearchWidget />
				<HeaderSearchWidget />
				<SiteSearchWidget />
				<MotorHomeBookingWidget />
				<ItineraryBookingWidget />
				<HotelsBookingWidget />
				<AuthHeader />

				<CarHireSearchPage />
				<MotorHomeSearchPage />
				<HotelSearchPage />
				<HolidaySearchPage />
				<FindMyHolidayPage />
				<MarketingMaterialSearch />
				<FlightSpecialOfferSearch />
				<FlightSearchPage />
			</>
		</Router>
	);
}

export default AppRouter;
